import React from 'react';
import { FormBuilder } from 'commons-ui';

import { BULK_FORM_FIELD_CONFIG, BULK_FORM_LAYOUT_CONFIG, validationSchemaForBulkConfiscation } from '../../utils/formConfig';

import useCreate from './useCreate';

const CreateBulkConfiscationAndRefund: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchemaForBulkConfiscation}
			setShowLoader={setShowLoader}
			fieldConfig={BULK_FORM_FIELD_CONFIG}
			layoutConfig={BULK_FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CreateBulkConfiscationAndRefund;
